import React, { useState } from 'react';

const SklopiviMini = (props) => {
  let initialOpened = false;
  if (props.initialOpened === true) {
    initialOpened = true;
  }
  const [opened, setOpened] = useState(initialOpened);
  const [rendering, setRendering] = useState(initialOpened);

  let _trouglic = (e) => {
    // console.log('klik na trouglic');
    if (opened) {
      setOpened(false);
    } else {
      setOpened(true);
      if (rendering !== true) {
        setRendering(true);
      }
    }
  }

  let alwaysOpened = false;
  if (props.alwaysOpened === true) {
    alwaysOpened = true;
  }

  let clOpened = '';
  if (opened || alwaysOpened) {
    clOpened = ' opened ';
  }

  let extraClass = '';
  if (typeof props.extraClass === 'string' && props.extraClass !== '') {
    extraClass = ' ' + props.extraClass;
  }

  let jsxTitle = null;
  if (typeof props.title === 'string' && props.title !== '') {
    jsxTitle = (
      <div className="title">
        <abbr title={props.tooltip}>{props.title}</abbr>
      </div>
    );
  }

  // posto sada saljemo i header a trouglic je samostalan, ovoj komponenti ne treba vise sopstveni header
  // i header i ipading su izbaceni. sve se sada prosledjuje kao children ovoj komponenti koja se samo bavi sklapanjem odnosno visinom elementa.

  let jsx = null;
  if (rendering) {
    jsx = (
      <>
        { props.children}
      </>
    );
  }
  return (
    <div className={"widget-sklopivi-mini " + clOpened + extraClass}>
      <div className="unicompo-rotating-triangle__aura-clickable" onClick={_trouglic}>
        <i className="fa fa-caret-right" aria-hidden="true"></i>
      </div>
      <div className="sklopivi-mini-header">
        <span onClick={_trouglic}>{jsxTitle}</span>
      </div>
      <div className="sklopivi-mini">
        {jsx}
      </div>
    </div>
  )
}

export default SklopiviMini;